<template>
  <div>
    <BRow
      class="mt-2 mb-1"
    >
      <BCol
        lg="6"
        class="my-1"
      >
        <Information
          :name="uData.full_name"
          :username="uData.user_name"
          :status="uData.verification_ktp_status"
          :gender="uData.gender"
          :phone="uData.phone_number"
          :email="uData.email"
          :address="uData.address"
          :partner-id="uData.partner_id"
          :ktp-id="uData.partner_ktp_verif_id"
          @update-user-data="$emit('update-user-data')"
        />
        <Summary
          class="my-1"
          :brand-name="uData.brand_name"
          :kmpoin="uData.kmpoin"
          :finance-menu="financeMenu"
          :modal-value="modalValue"
          @update-user-data="$emit('update-user-data')"
        />
      </BCol>
      <BCol
        lg="6"
        class="my-1"
      >
        <BOverlay
          :show="isLoadingSimilarityAccount"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <card-similarity-account :similar-accounts="similarAccounts" />
        </BOverlay>
      </BCol>
    </BRow>
    <BRow class="mb-1">
      <BCol class="my-1">
        <BOverlay
          :show="isLoadingLogsChange"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <card-products :products="uData.products" />
        </BOverlay>
      </BCol>
    </BRow>
    <BRow class="mb-1">
      <BCol class="my-1">
        <BOverlay
          :show="isLoadingLogsChange"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <card-logs
            :logs-changed="logsChanged"
            @update-user-data="$emit('update-user-data')"
          />
        </BOverlay>
      </BCol>
    </BRow>
  </div>
</template>

<style scoped>
@media screen and (min-width: 1280px) {
  .general {
    flex-direction: row !important;
    justify-content: space-between !important;
  }
  .general > *:first-child {
    width: calc(100% - 511px) !important;
  }
  .general > *:nth-child(2) {
    width: 510px !important;
  }
}
</style>

<script>
import CardSimilarityAccount from './component/CardSimilarityAccount.vue'
import Information from './component/Information.vue'
import Summary from './component/Summary.vue'
import CardProducts from './component/CardProducts.vue'
import CardLogs from './component/CardLogs.vue'

export default {
  components: {
    Information,
    Summary,
    CardSimilarityAccount,
    CardProducts,
    CardLogs,
  },
  props: {
    userData: {
      type: Object,
      default: () => ({
        full_name: '-',
        user_name: '-',
        gender: 0,
        phone_number: '-',
        email: '-',
        address: '-',
        products: null,
        kmpoin: 0,
        brand_name: null,
        verification_ktp_status: 0,
        partner_id: 1,
        partner_ktp_verif_id: null,
      }),
    },
    similarAccounts: {
      type: Object,
      default: () => {},
    },
    logsChanged: {
      type: Object,
      default: () => null,
    },
    isLoadingLogsChange: {
      type: Boolean,
      default: false,
    },
    isLoadingSimilarityAccount: {
      type: Boolean,
      default: false,
    },
    financeMenu: {
      type: Object,
      default: () => ({
        topupMenu: false,
        transferSaldo: false,
      }),
    },
    modalValue: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    uData() {
      return this.userData
    },
  },
}
</script>
